import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=49905798&scoped=true&"
import script from "./Photo.vue?vue&type=script&lang=ts&"
export * from "./Photo.vue?vue&type=script&lang=ts&"
import style0 from "./Photo.vue?vue&type=style&index=0&id=49905798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49905798",
  null
  
)

export default component.exports